import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { HotelContext } from "../context/HotelContext";
import { getDefaultHotelPath, parseHotelFeatureNames } from "../utils/hotelNavigation";
import { hotelHasV2Entry } from "../config/pageRegistry";

/**
 * Si l'hôtel n'a pas d'accès V2 (ex. GreenMiles V1 seul), sortir du shell V2.
 */
export const useV1AppRedirect = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { hId } = useContext(HotelContext);

  useEffect(() => {
    if (!hId || !auth.isAuthenticated || !auth.user?.access_token) {
      return;
    }

    if (!location.pathname.startsWith("/hotel/lunishower/v2")) {
      return;
    }

    let cancelled = false;

    fetch(`/api/hotels/${hId}/subscriptions/`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + auth.user.access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((subData) => {
        if (cancelled) return;
        const hotelFeatures = parseHotelFeatureNames(subData);
        if (!hotelHasV2Entry(hotelFeatures)) {
          navigate(getDefaultHotelPath(hotelFeatures), { replace: true });
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [hId, auth.isAuthenticated, auth.user?.access_token, location.pathname, navigate]);
};
